import script from "./WelcomeSetupNameStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeSetupNameStep.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeSetupNameStep.vue?vue&type=style&index=0&id=0f3ae6d3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f3ae6d3"]])

export default __exports__